import SignatureScreen from "react-native-signature-canvas";
import { useRef } from 'react'
import { Button} from '@ui-kitten/components';
import { View } from 'react-native';
const Sign = ({ text, onOK, toggle }) => {
  const ref = useRef();

  // Called after ref.current.readSignature() reads a non-empty base64 string
  const handleOK = (signature) => {
    console.log(signature);
    onOK(signature);
    toggle() // Callback from Component props
  };

  // Called after ref.current.readSignature() reads an empty string
  const handleEmpty = () => {
    console.log("Empty");
  };

  // Called after ref.current.clearSignature()
  const handleClear = () => {
    console.log("clear success!");
  };

  // Called after end of stroke
  const handleEnd = () => {
    ref.current.readSignature();
  };

  // Called after ref.current.getData()
  const handleData = (data) => {
    console.log(data);
  };

  return (
    <>
    <SignatureScreen
      ref={ref}
      onOK={handleOK}
      onEmpty={handleEmpty}
      onClear={handleClear}
      onGetData={handleData}
      autoClear={true}
      descriptionText={text}
    />
    <View style={{flexDirection:'row', justifyContent:'flex-end', marginTop:20}}>
    <Button appearance='ghost' style={{marginHorizontal:5, flex:2}} onPress={() => ref.current.clearSignature()}>
       پاک کردن
     </Button>
    <Button style={{marginHorizontal:5, flex:2}} onPress={handleEnd}>
       تایید
     </Button>
     </View>
     </>
  );
};

export default Sign;
